// statisticsSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  searchQuery: '',
  selectedRole: '',
  isAutocompleteFocused: false,
  user: {},
};

const statisticsSlice = createSlice({
  name: 'statistics',
  initialState,
  reducers: {
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
    setSelectedRole: (state, action) => {
      state.selectedRole = action.payload;
    },
    setAutocompleteFocus: state => {
      state.isAutocompleteFocused = true;
    },
    resetAutocompleteFocus: state => {
      state.isAutocompleteFocused = false;
    },
    setCurrentUser: (state, action) => {
      state.user = action.payload;
    },
  },
});

export const { setSearchQuery, setSelectedRole, setAutocompleteFocus, resetAutocompleteFocus, setCurrentUser } =
  statisticsSlice.actions;

export const selectSearchQuery = state => state.statistics.searchQuery;
export const selectSelectedRole = state => state.statistics.selectedRole;
export const selectIsAutocompleteFocused = state => state.statistics.isAutocompleteFocused;
export const selectCurrentUser = state => state.statistics.user;

export default statisticsSlice.reducer;
